export enum AppType {
  UNKNOWN = "unknown",
  GRAFANA = "grafana",
}
